
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/termos",
      function () {
        return require("private-next-pages/home/termos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home/termos"])
      });
    }
  